import React from "react";
import { Box, Card, CardContent, Typography, Grid } from "@material-ui/core";
import { Link } from "react-router-dom";
import NumberFormat from "react-number-format";
import { client } from "../../../service/ApolloClient/ApolloClient";
import { QUERY_CHEQUES } from "../../../service/ApolloClient/ApolloQueries";
import MaterialTableRtl from "../../UI/MaterialTableRtl/MaterialTableRtl";

class ChequeSummaryTables extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      activeTab: "all",
    };
  }

  getColumns = () => {
    return [
      {
        title: "#",
        field: "id",
        render: (rowData) => <Link to={`/cheque/edit/${rowData.id}`}>{rowData.id}</Link>,
      },
      {
        title: "مبلغ",
        field: "amount",
        render: (rowData) => (
          <NumberFormat value={rowData.amount} thousandSeparator={true} displayType={"text"} />
        ),
      },
      { title: "سررسید", field: "due_date_fa" },
      { title: "شماره چک", field: "cheque_id" },
      { title: "شماره صیاد", field: "icis" },
      {
        title: "دهنده",
        field: "giver_user_fullname",
        render: (rowData) =>
          rowData.giver_user_id ? (
            <a href={`/person/edit/${rowData.giver_user_id}`}>{rowData.giver_user_fullname}</a>
          ) : (
            "مشخص نشده"
          ),
      },
      {
        title: "مالک",
        field: "first_party_fullname",
        render: (rowData) =>
          rowData.first_party_id ? (
            <a href={`/person/edit/${rowData.first_party_id}`}>{rowData.first_party_fullname}</a>
          ) : (
            "مشخص نشده"
          ),
      },
      {
        title: "وضعیت",
        field: "status",
        render: (rowData) => {
          if (rowData.status === "cashed") return <span style={{ color: "green" }}>پاس شده</span>;
          if (rowData.status === "bounced") return <span style={{ color: "red" }}>برگشتی</span>;
          if (rowData.status === "returned-settlement") return <span style={{ color: "orange" }}>عودتی - تسویه</span>;
          if (rowData.status === "returned-unresolved") return <span style={{ color: "orange" }}>عودتی - بلاتکلیف</span>;
          return <span style={{ color: "grey" }}>جاری</span>;
        },
      },
    ];
  };

  fetchAllCheques = (query) => {
    const userId = parseInt(this.props.userId);
    
    const baseVariables = {
      page: query.page + 1,
      limit: query.pageSize,
      search: query.search,
      orderBy: query.orderBy ? query.orderBy.field : null,
      orderDirection: query.orderDirection,
    };

    return Promise.all([
      client.query({
        query: QUERY_CHEQUES,
        variables: { ...baseVariables, giver_user_id: userId },
        fetchPolicy: "network-only",
      }),
      client.query({
        query: QUERY_CHEQUES,
        variables: { ...baseVariables, first_party_id: userId },
        fetchPolicy: "network-only",
      }),
    ]).then(([giverResult, ownerResult]) => {
      const giverCheques = structuredClone(giverResult.data.cheques.data);
      const ownerCheques = structuredClone(ownerResult.data.cheques.data);
      
      const mergedMap = new Map();
      [...giverCheques, ...ownerCheques].forEach((cheque) => {
        mergedMap.set(cheque.id, cheque);
      });
      
      const merged = Array.from(mergedMap.values());
      const totalCount = giverResult.data.cheques.total + ownerResult.data.cheques.total;

      return {
        data: merged,
        page: query.page,
        totalCount: totalCount,
      };
    });
  };

  fetchFilteredCheques = (query, status) => {
    const userId = parseInt(this.props.userId);
    
    return client
      .query({
        query: QUERY_CHEQUES,
        variables: {
          page: query.page + 1,
          limit: query.pageSize,
          user: userId,
          status: status,
          search: query.search,
          orderBy: query.orderBy ? query.orderBy.field : null,
          orderDirection: query.orderDirection,
        },
        fetchPolicy: "network-only",
      })
      .then((res) => {
        let data = structuredClone(res.data);
        return {
          data: data.cheques.data,
          page: query.page,
          totalCount: data.cheques.total,
        };
      });
  };

  fetchData = (query) => {
    const { activeTab } = this.state;

    if (activeTab === "all") {
      return this.fetchAllCheques(query);
    }

    const statusMap = {
      bounced: "bounced",
      cashed: "cashed",
      current: "current",
      returned: "returned-settlement",
    };

    return this.fetchFilteredCheques(query, statusMap[activeTab]);
  };

  render() {
    const { activeTab } = this.state;
    const tabs = [
      { key: "all", label: "همه چک ها" },
      { key: "bounced", label: "چک های برگشتی" },
      { key: "cashed", label: "چک های پاس شده" },
      { key: "current", label: "چک های جاری" },
      { key: "returned", label: "چک های عودتی" },
    ];

    return (
      <Card style={{ marginBottom: 16 }}>
        <CardContent>
          <Typography variant="h6" gutterBottom style={{ fontWeight: "bold", marginBottom: 16 }}>
            خلاصه چک ها
          </Typography>
          <Grid container spacing={1} style={{ marginBottom: 16 }}>
            {tabs.map((tab) => (
              <Grid item key={tab.key}>
                <Box
                  component="span"
                  onClick={() => this.setState({ activeTab: tab.key })}
                  style={{
                    padding: "8px 16px",
                    borderRadius: 4,
                    cursor: "pointer",
                    backgroundColor: activeTab === tab.key ? "#3f51b5" : "#e0e0e0",
                    color: activeTab === tab.key ? "#fff" : "#333",
                    fontWeight: activeTab === tab.key ? "bold" : "normal",
                    fontSize: 14,
                  }}
                >
                  {tab.label}
                </Box>
              </Grid>
            ))}
          </Grid>
          <MaterialTableRtl
            key={activeTab}
            columns={this.getColumns()}
            data={this.fetchData}
            editLink={"/cheque/edit/"}
            perPage={5}
            needExport={false}
            title={`چک های ${tabs.find((t) => t.key === activeTab)?.label || ""}`}
          />
        </CardContent>
      </Card>
    );
  }
}

export default ChequeSummaryTables;
